import { render, staticRenderFns } from "./c-button-help.vue?vue&type=template&id=494c795c&scoped=true&"
import script from "./c-button-help.vue?vue&type=script&lang=js&"
export * from "./c-button-help.vue?vue&type=script&lang=js&"
import style0 from "./c-button-help.vue?vue&type=style&index=0&id=494c795c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c795c",
  null
  
)

export default component.exports